import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resendConfirmationEmail } from "../../api/userApi";
import "./ResendConfirmation.css"; // Styles
import HomeButton from "../common/HomeButton";

const ResendConfirmation = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        try {
            await resendConfirmationEmail(email);
            const loginLink = () => (
                <div>
                  <p>{t('resendConfirmation.success')}</p>
                  {/* <button className='link-button' onClick ={() => navigate('/login')}>{t('resendConfirmation.login')}</button> */}
                </div>
              )            
            setMessage(loginLink());
        } catch (error) {
            if (error.response && error.response.status === 429) {
                setError(t('resendConfirmation.tooManyRequests'))
            } else if (error.response && error.response.status === 400) {
                const response = error.response.data;
                if (response.message === 'email is not valid') {
                    setError(t('resendConfirmation.errorEmailInvalid'));  
                } else if (response.message === 'Email is required') {
                    setError(t('resendConfirmation.errorEmailInvalid'));  
                } else {
                    setError(t('resendConfirmation.fail'));                
                }
            } else {
                setError(t('resendConfirmation.fail'));
            }
        }
    };

    return (
        <div className="resend-confirmation-container">
            <HomeButton />
            <h2>Resend Confirmation Email</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder={t('resendConfirmation.email')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button className="big-button action-button" type="submit">{t('resendConfirmation.send')}</button>
            </form>
            {message && <p className="message">{message}</p>}
            {error && <p className="form-error">{error}</p>}
            <button className='link-button' onClick ={() => navigate('/login')}>{t('resendConfirmation.login')}</button>
        </div>
    );
};

export default ResendConfirmation;
